import { render, staticRenderFns } from "./PodEmailForm.vue?vue&type=template&id=2984452d&"
import script from "./PodEmailForm.vue?vue&type=script&lang=js&"
export * from "./PodEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports